import React from 'react';
import styled from 'styled-components';

import { AlertError } from '@ad-scripts/presentation/components/common/alert';

type Props = {
  archivedAt: string;
};

const ArchivalAlert = ({ archivedAt }: Props): JSX.Element | null => {
  const formattedArchivalDate = new Date(archivedAt).toLocaleString('default', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div>
      <StyledAlertErrorNotification data-aid="alert-error-notification-disabled-custom-attribute">
        <div>
          <b>This freeform topic was archived on {formattedArchivalDate}.</b> Activate it to turn it back on.
        </div>
      </StyledAlertErrorNotification>
    </div>
  );
};

export default ArchivalAlert;

const StyledAlertErrorNotification = styled(AlertError)`
  min-width: 600px;
  min-height: 50px;
  margin-top: 10px;
  margin-bottom: 24px;
  line-height: 162%;

  svg {
    margin-top: 4px;
  }
`;
